// extracted by mini-css-extract-plugin
export default {"spinner":"Oy_8Pd","spinner-animation":"g_GKia","spinner_view_dark-yellow":"Im4pw9","spinner_view_dark-white":"Vs10jD","spinner_view_yellow-white":"X4cC41"};